import { FieldArray, Form, Formik } from "formik";
import {
  BALANCE_MASSE_INITIAL_VALUE,
  balanceIV,
  balanceMasseValidationSchema,
} from "../../models/balanceTenant";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import Card from "../UI/Card";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { Croix, PlusBank } from "../UI/Icons";
import style from "./BalanceMasseForm.module.css";
import BalanceFields from "./BalanceFields";
import { produce } from "immer";
import {
  classnames,
  handleAPIError,
  setBalanceAmountSignFromType,
} from "../../utils/index.jsx";
import { useBalanceTypes } from "../../hooks/use-balances";
import ButtonCard from "../UI/ButtonCard";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import { useToast } from "../UI/Toast/useToast";
import { BalanceDomain } from "../../utils/constants/balances";
import { toBalanceDetailsPayload } from "../../utils/balances";
import { PropertyType } from "../../models/property";

export default function BalanceMasseForm({
  balances,
  open,
  onOpenChange,
  onSubmit,
  domaineBalance,
  propertyType,
}) {
  const initialValues = toInitialValuesFromSchema(
    balanceMasseValidationSchema,
    { balances },
    BALANCE_MASSE_INITIAL_VALUE,
  );
  const toast = useToast();

  const { balanceTypesByCategory, isLoading } = useBalanceTypes();
  if (isLoading) return null;

  async function submitHandler(values, { resetForm }) {
    const vals = produce(sanitizeValues(values), (draft) => {
      draft.balances.forEach((balance) => {
        // change to negative if type is Appel .*
        balance.montant = setBalanceAmountSignFromType(
          balance,
          balanceTypesByCategory,
        );
        if (!balance.domaine) balance.domaine = domaineBalance;
        balance.details = toBalanceDetailsPayload(balance.details);
      });
    });
    try {
      await onSubmit(vals.balances);
      resetForm();
    } catch (error) {
      toast.error({ title: handleAPIError(error) });
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={balanceMasseValidationSchema}
      onSubmit={submitHandler}
    >
      {({ values, dirty, resetForm }) => (
        <ModalDialog
          size="xl"
          open={open}
          header="Édition multiple"
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              if (
                dirty &&
                !window.confirm(
                  "Votre formulaire n'a pas été sauvegardé. Voulez-vous vraiment quitter ?",
                )
              ) {
                return;
              }
              resetForm();
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <ModalDialogBody>
              <FieldArray
                name="balances"
                render={(arrayHelpers) => (
                  <>
                    {(domaineBalance !== BalanceDomain.FOLDER ||
                      propertyType === PropertyType.BIEN_COMPTABLE) && (
                      <ButtonCard
                        className={`flex justify-content-center align-items-center w-100 marginB10`}
                        padding={"sm"}
                        onClick={() =>
                          arrayHelpers.unshift({
                            ...balanceIV,
                            domaine: domaineBalance,
                          })
                        }
                      >
                        <PlusBank />
                        <p className={"secondaryText marginL10"}>
                          Ajouter une entrée
                        </p>
                      </ButtonCard>
                    )}
                    {values.balances.map((balance, i) => (
                      <Card
                        className={classnames(
                          "padding10",
                          "marginB10",
                          balance.id && "bg-blue",
                        )}
                        key={i}
                      >
                        <div
                          className={style.delete}
                          onClick={() => arrayHelpers.remove(i)}
                        >
                          <Croix />
                        </div>
                        <div className="flex wrap gap10">
                          <BalanceFields
                            prefix={`balances.${i}.`}
                            isFromTransac={!!balance.id_transaction}
                          />
                        </div>
                      </Card>
                    ))}
                    {(domaineBalance !== BalanceDomain.FOLDER ||
                      propertyType === PropertyType.BIEN_COMPTABLE) && (
                      <ButtonCard
                        className={`flex justify-content-center w-100 align-items-center marginB10`}
                        padding={"sm"}
                        onClick={() =>
                          arrayHelpers.push({
                            ...balanceIV,
                            domaine: domaineBalance,
                          })
                        }
                      >
                        <PlusBank />
                        <p className={"secondaryText marginL10"}>
                          Ajouter une entrée
                        </p>
                      </ButtonCard>
                    )}
                  </>
                )}
              />
            </ModalDialogBody>
            <ModalDialogFooter>
              <FormikSubmitButton requiresWrite>Valider</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
